import React from "react";
import ComingSoon from "@/components/common/ComingSoon";
import { Coins, CalendarClock, Hammer, Sparkles, FileBarChart } from "lucide-react";

export const FinancesPage = () => (
  <ComingSoon icon={Coins} title="Finances & fiscalité"
    description="Trésorerie par SCI, crédits immobiliers, TVA française, comptes annuels et liasse fiscale simplifiée." />
);

export const EcheancesPage = () => (
  <ComingSoon icon={CalendarClock} title="Échéances"
    description="Loyers, charges, échéances de prêts, assurances, taxes foncières. Alertes intelligentes prévues." />
);

export const ProjetsPage = () => (
  <ComingSoon icon={Hammer} title="Projets immobiliers"
    description="Suivi des projets d'acquisition, travaux, marchand de biens : jalons, budget, DPE, mandats." />
);

export const AssistantPage = () => (
  <ComingSoon icon={Sparkles} title="Assistant IA"
    description="Un assistant patrimonial qui répondra à vos questions fiscales, juridiques et opérationnelles. Intégration IA prévue dans une phase dédiée." />
);

export const RapportsPage = () => (
  <ComingSoon icon={FileBarChart} title="Rapports"
    description="Tableaux de bord fiscaux, situation locative, performance patrimoniale, exports comptables au format FEC." />
);
